"use client";
import { useTranslations } from "next-intl";
import React, { useState } from "react";
import AuthModalContainer from "./authModalContainer";
import HeadLine from "../headLine";
import SendOtpForm from "../sendOtpForm";
import VerifySendOtpForm from "../verifyOtpForm";
type TFormStep = "send-otp" | "verify-otp";
const SendOtpModal = () => {
  const t = useTranslations("auth");
  const [formStep, setFormStep] = useState<TFormStep>("send-otp");

  const forms = {
    "send-otp": {
      headline: t("headlines.loginHeadline"),
      form: (
        <SendOtpForm
          nextFormStep={() => setFormStep("verify-otp")}
          btnLabel={t("buttons.sendOtpSubmit")}
        />
      ),
    },
    "verify-otp": {
      headline: t("headlines.verifyOtpHeadline"),
      form: <VerifySendOtpForm backFormStep={() => setFormStep("send-otp")} />,
    },
  };

  return (
    <AuthModalContainer formMode="otp">
      <HeadLine>{forms[formStep].headline}</HeadLine>
      {forms[formStep].form}
    </AuthModalContainer>
  );
};

export default SendOtpModal;
